module.exports = __webpack_public_path__ + "static/img/manual-24.117f87a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-24.png
// module id = Opq2
// module chunks = 4